import { formatToReal } from '@cannect/utils/number'
import { FREE_NATIONAL_FREIGHT_LABEL, shouldShowNationalFreight } from '@cannect/utils/nationalFreight'

interface CartSummaryProps {
  subtotal: number
  shipping: number
  discount: number
  total: number
  noImportCost: boolean
  shippingDiscount: number
  nationalFreight?: number
  nationalFreightQuoted?: boolean
}

export function CartSummary({
  subtotal,
  shipping,
  discount,
  total,
  shippingDiscount,
  noImportCost = false,
  nationalFreight = 0,
  nationalFreightQuoted = false
}: CartSummaryProps) {
  return (
    <div className="space-y-2 border-t border-gray-200 pt-4">
      {parseFloat(subtotal.toString()) > 0 && (
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Total de produtos:</span>
          <span className="font-medium">{formatToReal(Number(subtotal))}</span>
        </div>
      )}

      {parseFloat(discount.toString()) > 0 && (
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Desconto:</span>
          <span className="font-medium">-{formatToReal(Number(discount))}</span>
        </div>
      )}

      {!noImportCost && parseFloat(shipping.toString()) > 0 && (
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Custo de importação:</span>
          <span className="font-medium">{formatToReal(Number(shipping) + Number(shippingDiscount))}</span>
        </div>
      )}

      {parseFloat(shippingDiscount.toString()) > 0 && (
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Desconto de importação:</span>
          <span className="font-medium">-{formatToReal(Number(shippingDiscount))}</span>
        </div>
      )}

      {shouldShowNationalFreight(nationalFreight, nationalFreightQuoted) && (
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Frete nacional:</span>
          <span className="font-medium">
            {nationalFreight > 0 ? formatToReal(nationalFreight) : FREE_NATIONAL_FREIGHT_LABEL}
          </span>
        </div>
      )}

      <div className="mb-4 flex items-center justify-between border-t border-gray-200 pt-2 text-lg font-bold">
        <div className="flex min-w-0 flex-1 items-center gap-1">
          <span className="whitespace-nowrap">Total</span>
          {!noImportCost && (
            <span className="truncate text-xs font-normal text-gray-500 sm:text-sm">(Custo de importação incluso)</span>
          )}
        </div>
        <span className="ml-2 whitespace-nowrap">{formatToReal(Number(total))}</span>
      </div>
    </div>
  )
}
